import React from 'react';

import { MODAL_NAMES } from '@constants/modalRenderers';

import type { IAIReport } from '@model/aiReport';

import TranslateBtn from '@pages/ActionItem/components/TranslateBtn/TranslateBtn';
import useLiveTranslate from '@pages/ActionItem/hooks/useLiveTranslate';
import type { ITranslate } from '@pages/ActionItem/model/ITranslate';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  text: string;
  label: string;
  hasTranslateField?: boolean;
  translationKeys?: {
    fields: 'text' | 'no_actions_description' | 'decline_reason' | 'ww_comment' | 'cause';
    entityName: string;
    entityId: number;
  };
  report?: IAIReport;
  extraLabel?: string;
}

const TextareaFieldComponent: React.FC<IProps> = ({
  label = '',
  translationKeys = { fields: '', entityName: '', entityId: undefined },
  report,
  extraLabel,
}) => {
  const { setActiveModal } = useModalActions();

  const { fields, entityName, entityId } = translationKeys;

  const { hasTranslate, translates, isTranslated, isTranslateLoading, toggleIsTranslate } = useLiveTranslate({
    item: report,
    fields: [fields],
    entityName,
    entityId,
  });

  const handleOpenLightbox = (event: React.MouseEvent<HTMLElement>): void => {
    const target = event.target;

    if (!(target instanceof HTMLImageElement) || !fields) return;
    const images = report?.[fields]?.match(/<img [^>]*src="[^"]*"[^>]*>/gm)!.map((x) => {
      return { src: x.replace(/.*src="([^"]*)".*/, '$1') };
    });

    if (images?.length) {
      const index = images.findIndex((image) => image?.src === target?.currentSrc);

      setActiveModal({ name: MODAL_NAMES.lightboxModal, options: { images, index } });
    }
  };

  return (
    <>
      <div className={style.fieldBlock}>
        <div className={style.fieldLabel}>
          <div>
            {label}
            {extraLabel && <div className={style.extraLabel}>{extraLabel}</div>}
          </div>
          <TranslateBtn
            isTranslated={isTranslated}
            hasTranslate={hasTranslate}
            isTranslateLoading={isTranslateLoading}
            toggleIsTranslate={toggleIsTranslate}
          />
        </div>
        <div
          className={style.textareaField}
          dangerouslySetInnerHTML={{ __html: translates[fields] }}
          onClick={(event) => handleOpenLightbox(event)}
        />
      </div>
    </>
  );
};

export default TextareaFieldComponent;
